export enum ImpositionStatus {
  Activo = 'ACTIVO',
  Cancelado = 'CANCELADO',
  Vencido = 'VENCIDO',
}
